var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackIcon = function SvgBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M17.048 9.037H5.61a.168.168 0 0 1-.11-.292l5.773-5.08a.963.963 0 0 0-1.27-1.446L2.53 8.796a1.604 1.604 0 0 0 0 2.407l7.473 6.576a.963.963 0 0 0 1.27-1.445l-5.774-5.08a.167.167 0 0 1 .11-.293h11.44a.963.963 0 0 0 0-1.925v.001z"
  })));
};
export { SvgBackIcon as ReactComponent };